import React from 'react';
import { SlideLayout } from '../components/SlideLayout';
import { Button } from '../components/Button';
import { MapPinIcon, PhoneIcon, MailIcon, ArrowLeft } from 'lucide-react';
interface Slide9Props {
  onNavigate: (slide: number) => void;
}
export function Slide9({
  onNavigate
}: Slide9Props) {
  return <SlideLayout onBack={() => onNavigate(7)} data-id="element-242">
      <div className="w-full max-w-4xl mx-auto space-y-12" data-id="element-243">
        <h1 className="text-4xl font-bold text-white text-center mb-8 uppercase" data-id="element-244">
          CONTACT ROCHE CÔTE D'IVOIRE
        </h1>
        <div className="frosted-card rounded-2xl shadow-xl p-12 space-y-8" data-id="element-245">
          <div className="text-center mb-8" data-id="element-246">
            <h2 className="text-3xl font-bold text-[#1B3A5C] mb-2" data-id="element-247">
              Roche Côte d'Ivoire SARL
            </h2>
          </div>
          <div className="space-y-6" data-id="element-248">
            <div className="flex items-start gap-6" data-id="element-249">
              <MapPinIcon className="w-8 h-8 text-[#0E8585] flex-shrink-0 mt-1" data-id="element-250" />
              <div data-id="element-251">
                <p className="text-xl text-[#1B3A5C] font-bold mb-1" data-id="element-252">ADDRESS</p>
                <p className="text-white text-lg" data-id="element-253">
                  Ivoire Trade Center, Cocody les Ambassades
                </p>
                <p className="text-white text-lg" data-id="element-254">
                  Angle Rue Hassan II & Rue Booker Washington
                </p>
              </div>
            </div>
            <div className="flex items-start gap-6" data-id="element-255">
              <PhoneIcon className="w-8 h-8 text-[#0E8585] flex-shrink-0 mt-1" data-id="element-256" />
              <div data-id="element-257">
                <p className="text-xl text-[#1B3A5C] font-bold mb-1" data-id="element-258">PHONE</p>
                <p className="text-white text-lg" data-id="element-259">+225 27 22 48 23 55</p>
              </div>
            </div>
            <div className="flex items-start gap-6" data-id="element-260">
              <MailIcon className="w-8 h-8 text-[#0E8585] flex-shrink-0 mt-1" data-id="element-261" />
              <div data-id="element-262">
                <p className="text-xl text-[#1B3A5C] font-bold mb-1" data-id="element-263">EMAIL</p>
                <p className="text-white text-lg" data-id="element-264">
                  westafricapharmacovigilance@roche.com
                </p>
                <p className="text-white text-lg" data-id="element-265">
                  westafrica.medinfo@roche.com
                </p>
              </div>
            </div>
          </div>
        </div>
        <div className="flex justify-center gap-4 pt-4" data-id="element-266">
          <Button variant="secondary" onClick={() => onNavigate(7)} data-id="element-267">
            BACK TO RESOURCES
          </Button>
          <Button variant="primary" onClick={() => onNavigate(2)} data-id="element-268">
            BACK TO MAIN MENU
          </Button>
        </div>
      </div>
    </SlideLayout>;
}